export default {
	ALTERNATIVE_INGREDIENT: 'Alternative ingredient',
	WITHOUT_THE_INGREDIENT: 'Without the ingredient',
	ALTERNATIVE_PRODUCTS: 'Alternative products',
};
